import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue";
var _hoisted_1 = {
  class: "user-info-body"
};
var _hoisted_2 = {
  class: "content-left"
};
var _hoisted_3 = {
  class: "user-info"
};
var _hoisted_4 = {
  class: "info-top"
};
var _hoisted_5 = {
  class: "user-name"
};
var _hoisted_6 = {
  key: 0,
  class: "rank-name"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  key: 0,
  class: "info-bottom"
};
var _hoisted_9 = {
  class: "level-info"
};
var _hoisted_10 = {
  class: "margin-r8"
};
var _hoisted_11 = {
  class: "level-progress"
};
var _hoisted_12 = {
  class: "margin-r8"
};
var _hoisted_13 = {
  class: "level-point"
};
import { ref, watch, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import Avatar from './Avatar.vue';
import { useTaskApi } from '@/hooks/useTaskApi';
import { getUserDecorationList } from '../../../api/user';
export default {
  __name: 'userInfoView',
  props: {
    userInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    clickRightValue: {
      type: Number,
      default: 0
    }
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var _useTaskApi = useTaskApi(),
      fetchUserTypeSchoolList = _useTaskApi.fetchUserTypeSchoolList,
      fetchCurrentSemesterBySchoolId = _useTaskApi.fetchCurrentSemesterBySchoolId,
      fetchLevelRankDetail = _useTaskApi.fetchLevelRankDetail;
    var props = __props;
    var baseImg = require('@/assets/home/baseImg.svg');
    var router = useRouter();
    // 等级段位等信息
    var schoolList = ref([]);
    var schoolId = ref('');
    var semesterInfo = ref({});
    var levelInfo = ref({});
    var titleUrl = ref('');
    // 定义更新用户信息的函数
    var updateUserInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(userId) {
        var _schoolList$value$, _semesterInfo$value;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return fetchUserTypeSchoolList(userId, 1);
            case 1:
              schoolList.value = _context.v;
              schoolId.value = ((_schoolList$value$ = schoolList.value[0]) === null || _schoolList$value$ === void 0 ? void 0 : _schoolList$value$.schoolId) || '';
              if (!schoolId.value) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return fetchCurrentSemesterBySchoolId(schoolId.value);
            case 2:
              semesterInfo.value = _context.v;
            case 3:
              if (!((_semesterInfo$value = semesterInfo.value) !== null && _semesterInfo$value !== void 0 && _semesterInfo$value.id)) {
                _context.n = 5;
                break;
              }
              _context.n = 4;
              return fetchLevelRankDetail({
                userId: userId,
                semesterId: semesterInfo.value.id,
                currentSemesterFlag: 1
              });
            case 4:
              levelInfo.value = _context.v;
            case 5:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function updateUserInfo(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    // 暴露给父组件使用
    __expose({
      updateUserInfo: updateUserInfo
    });

    // 监听 userInfo，当有数据时调用 updateUserInfo
    watch(function () {
      return props.userInfo;
    }, function (newVal) {
      if (newVal && newVal.id) {
        updateUserInfo(newVal.id);
      }
    }, {
      deep: true
    });

    //  个人简介
    var goToPeople = function goToPeople(val) {
      if (!val) {
        router.push('/userInfo');
      }
    };
    var textShadow = function textShadow(val) {
      if (!val) {
        if (props.clickRightValue !== 1) return '';
        return '点击此处去完善个人简介';
      } else {
        return val;
      }
    };
    var initTitleInfo = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, titleList, activeTitle;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getUserDecorationList();
            case 1:
              res = _context2.v;
              if (res.data.code === 0) {
                //  取titleList列表下 isSelect = true的称号
                titleList = res.data.data.titleList || [];
                activeTitle = titleList.find(function (item) {
                  return item.isSelect;
                });
                if (activeTitle) {
                  titleUrl.value = activeTitle.imgUrl;
                }
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function initTitleInfo() {
        return _ref3.apply(this, arguments);
      };
    }();
    onMounted(function () {
      initTitleInfo();
    });
    return function (_ctx, _cache) {
      var _levelInfo$value, _levelInfo$value2, _levelInfo$value3, _levelInfo$value4, _levelInfo$value5, _levelInfo$value6, _levelInfo$value7, _levelInfo$value8;
      var _component_t_progress = _resolveComponent("t-progress");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(Avatar, {
        avatarUrl: __props.userInfo.avatar || _unref(baseImg),
        size: "50px"
      }, null, 8, ["avatarUrl"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(__props.userInfo.name), 1), (_levelInfo$value = levelInfo.value) !== null && _levelInfo$value !== void 0 && (_levelInfo$value = _levelInfo$value.teacherRankInfo) !== null && _levelInfo$value !== void 0 && _levelInfo$value.currentRankName ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString((_levelInfo$value2 = levelInfo.value) === null || _levelInfo$value2 === void 0 || (_levelInfo$value2 = _levelInfo$value2.teacherRankInfo) === null || _levelInfo$value2 === void 0 ? void 0 : _levelInfo$value2.currentRankName), 1)) : _createCommentVNode("", true), titleUrl.value ? (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: titleUrl.value,
        alt: "title",
        style: {
          "width": "80px",
          "height": "22px",
          "margin-left": "8px"
        }
      }, null, 8, _hoisted_7)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.userInfo.subjects, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "rank-name subject-item"
        }, _toDisplayString(item), 1);
      }), 128))]), Object.keys(levelInfo.value).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString((_levelInfo$value3 = levelInfo.value) === null || _levelInfo$value3 === void 0 || (_levelInfo$value3 = _levelInfo$value3.teacherLevelInfo) === null || _levelInfo$value3 === void 0 ? void 0 : _levelInfo$value3.currentLevelName), 1), _createElementVNode("div", _hoisted_11, [_createVNode(_component_t_progress, {
        percentage: ((_levelInfo$value4 = levelInfo.value) === null || _levelInfo$value4 === void 0 || (_levelInfo$value4 = _levelInfo$value4.userPointInfo) === null || _levelInfo$value4 === void 0 ? void 0 : _levelInfo$value4.teacherTotalPoint) / ((_levelInfo$value5 = levelInfo.value) === null || _levelInfo$value5 === void 0 || (_levelInfo$value5 = _levelInfo$value5.teacherLevelInfo) === null || _levelInfo$value5 === void 0 ? void 0 : _levelInfo$value5.nextLevelThreshold) * 100,
        trackColor: "#FCEFDF",
        color: "#FFA63A",
        label: false,
        size: "small"
      }, null, 8, ["percentage"])]), _createElementVNode("span", _hoisted_12, _toDisplayString("LV".concat((_levelInfo$value6 = levelInfo.value) === null || _levelInfo$value6 === void 0 || (_levelInfo$value6 = _levelInfo$value6.teacherLevelInfo) === null || _levelInfo$value6 === void 0 ? void 0 : _levelInfo$value6.currentLevelNum)), 1), _createElementVNode("span", _hoisted_13, _toDisplayString((_levelInfo$value7 = levelInfo.value) === null || _levelInfo$value7 === void 0 || (_levelInfo$value7 = _levelInfo$value7.userPointInfo) === null || _levelInfo$value7 === void 0 ? void 0 : _levelInfo$value7.teacherTotalPoint) + "/" + _toDisplayString(((_levelInfo$value8 = levelInfo.value) === null || _levelInfo$value8 === void 0 || (_levelInfo$value8 = _levelInfo$value8.teacherLevelInfo) === null || _levelInfo$value8 === void 0 ? void 0 : _levelInfo$value8.nextLevelThreshold) || '-'), 1)])])) : _createCommentVNode("", true)])]), _createElementVNode("div", {
        class: "introduce-body",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return goToPeople(__props.userInfo.personalProfile);
        })
      }, _toDisplayString(textShadow(__props.userInfo.personalProfile)), 1)]);
    };
  }
};